import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

import List from './CommentsList';

const ErrorBoundaryFallback = dynamic(() => import('./ErrorBoundaryFallback'), {
  ssr: false,
});

const CommentsList = forwardRef(
  (
    {
      className,
      gaEventCategory,
      isOfferCommentsAllowed,
      offerCommentsCount,
      offerId,
      offerKey,
      offerStatusName,
      reviews,
      serverComments,
    },
    ref
  ) => (
    <ErrorBoundary fallback={ErrorBoundaryFallback}>
      <List
        ref={ref}
        className={className}
        gaEventCategory={gaEventCategory}
        initialComments={serverComments}
        isCommentsAllowed={isOfferCommentsAllowed}
        isReadOnly={!isOfferCommentsAllowed}
        offerCommentsCount={offerCommentsCount}
        offerId={offerId}
        offerKey={offerKey}
        offerStatusName={offerStatusName}
        reviews={reviews}
      />
    </ErrorBoundary>
  )
);

CommentsList.displayName = 'DynamicallyLoadedOfferCommentsWithRef';

CommentsList.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isOfferCommentsAllowed: PropTypes.bool.isRequired,
  offerCommentsCount: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  // // `offerKey` is either `offerId` or an `offerSlug`
  offerKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  offerStatusName: PropTypes.string.isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      relevance: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      raw: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      likes: PropTypes.number.isRequired,
      statusName: PropTypes.string.isRequired,
      stars: PropTypes.number.isRequired,
      user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired,
        photo: PropTypes.string.isRequired,
        typeName: PropTypes.string.isRequired,
        level: PropTypes.number.isRequired,
        specialityName: PropTypes.string,
        link: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  serverComments: PropTypes.arrayOf(
    PropTypes.shape({
      commentId: PropTypes.number.isRequired,
      parentId: PropTypes.number,
      userId: PropTypes.number.isRequired,
      commentText: PropTypes.string.isRequired,
      commentRaw: PropTypes.string.isRequired,
      commentDate: PropTypes.string.isRequired,
      commentLikes: PropTypes.number.isRequired,
      commentStatusName: PropTypes.string.isRequired,
      commentFixed: PropTypes.bool.isRequired,
      relevance: PropTypes.number.isRequired,
      commentStars: PropTypes.number,
      reviewAliasId: PropTypes.number,
      edited: PropTypes.bool.isRequired,
      isReview: PropTypes.bool.isRequired,
      userLevel: PropTypes.number.isRequired,
      userName: PropTypes.string.isRequired,
      userPhoto: PropTypes.string.isRequired,
      userSpecialtyName: PropTypes.string,
      userTypeName: PropTypes.string.isRequired,
      userUsername: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string,
      replies: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    })
  ).isRequired,
};

export default CommentsList;
